import { render, staticRenderFns } from "./AlchemyTab.vue?vue&type=template&id=e633ed5c&scoped=true&"
import script from "./AlchemyTab.vue?vue&type=script&lang=js&"
export * from "./AlchemyTab.vue?vue&type=script&lang=js&"
import style0 from "./AlchemyTab.vue?vue&type=style&index=0&id=e633ed5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e633ed5c",
  null
  
)

export default component.exports